import { defineStore } from 'pinia';
import { useHttp } from '@/http/http';
import { statusCheck } from '../public';
import Swal from 'sweetalert2';

export const useTransactionStore = defineStore('transaction', {
  state: () => ({
    transactions: [],
    totalEntries: 0,
    currentPage: 1,
    itemsPerPage: 10,
  }),
  actions: {
    async fetchTransactions(page = this.currentPage, perPage = this.itemsPerPage, filters = {}) {
      const url = `/api/admin/transaction/list`;
      let params = new URLSearchParams();

      params.append('per_page', perPage);
      params.append('page', page);
      if (filters.transactionRef) params.append('reference', filters.transactionRef);
      if (filters.terminalId) params.append('tid', filters.terminalId);
      if (filters.driverId) params.append('driver_id', filters.driverId);
      if (filters.cardLast4) params.append('card_last_4_digits', filters.cardLast4);
      if (filters.cardType) params.append('card_type', filters.cardType);
      if (filters.contract) params.append('contract', filters.contract);
      if (filters.subgroup) params.append('subgroup_id', filters.subgroup);
      if (filters.plateState) params.append('plate_state', filters.plateState);
      if (filters.fromDate) params.append('from', filters.fromDate);
      if (filters.toDate) params.append('to', filters.toDate);
      if (filters.sort_by) params.append('sort_by', filters.sort_by);
      if (filters.order) params.append('order', filters.order);

      try {
        const response = await useHttp().get(`${url}?${params.toString()}`);
        if (statusCheck(response.data)) {
          this.transactions = response.data.transactions;
          this.totalEntries = response.data.total;
          this.currentPage = page;
          this.itemsPerPage = perPage;
        } else {

        }
      } catch (error) {
        console.error('Error fetching transactions:', error);
      }
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchTransactions(page, this.itemsPerPage);
      }
    },
    async uploadTransactions(csvFile) {
      try {
        const formData = new FormData();
        formData.append('transactions_csv', csvFile);

        const response = await useHttp().post('/api/admin/transaction/upload_data', formData);
        
        if (statusCheck(response.data)) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        console.error('Error uploading transactions:', error);
        throw error; 
      }
    },
  },
  getters: {
    paginatedData(state) {
      return state.transactions;
    },
    totalPages(state) {
      return Math.ceil(state.totalEntries / state.itemsPerPage);
    },
  },
});
